<template>
    <div class="detail">
        <section v-if="plugin" id="header__section">
            <div class="container">
                <div class="header__top">
                    <div class="header__top--left">
                        <plugin-logo :size="128" :type="plugin.image.type" :path="plugin.image.path"></plugin-logo>
                        <div class="header__left--meta">
                            <h1>{{plugin.name}}</h1>
                            <span class="creator">{{ $t('page.detail.created_by') }} <router-link :to="{path: '/vendor/' + plugin.creator.key + '-' + plugin.creator.id}">{{plugin.creator.value}}</router-link></span>
                            <span v-if="plugin.type == 'addon'" class="technology"><a>{{plugin.technologies.value}} {{ $t('page.detail.template') }}</a></span>
                            <span v-if="plugin.rating.count && plugin.type == 'addon'" class="rating">
                                <svg v-for="star in parseInt(Math.floor(plugin.rating.average))" :key="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 260 245"><path  fill="#575C61" d="m55,237 74-228 74,228L9,96h240"/></svg>
                                <svg v-for="star in parseInt(5 - Math.floor(plugin.rating.average))" :key="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 260 245"><path fill="rgb(87,92,97, 0.25)" d="m55,237 74-228 74,228L9,96h240"/></svg>
                                <span class="rating__counter">
                                    {{plugin.rating.count}}
                                </span>
                            </span>
                            <span v-if="plugin.downloads > 0 && plugin.type == 'addon'" class="Downloads">{{beautifyDownloads()}}</span>
                        </div>
                    </div>
                    <div class="header__top--right">
                        <a v-if="$store.state.loggedIn && plugin.type == 'addon'" class="highlight__plugin" @click="togglePluginHighlight()">
                            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="icons-/-filled-/-Heart" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <path v-if="plugin.highlight" d="M12,6.04168892 C9.33165018,-0.396099541 1,1.2374529 1,8.24936117 C1,9.44662657 1.42522258,10.7488894 2.21745959,12.1427661 C3.16055591,13.8020676 4.5996091,15.5528036 6.4023296,17.3429285 C7.56530417,18.4977774 8.80980511,19.5999935 10.0542382,20.6130947 C10.4898251,20.9677088 10.8944894,21.2860107 11.2579947,21.5633617 C11.4769961,21.7304577 11.6342722,21.8472421 11.7195736,21.9090561 C11.8869068,22.0303146 12.1130932,22.0303146 12.2804264,21.9090561 C12.3657278,21.8472421 12.5230039,21.7304577 12.7420053,21.5633617 C13.1055106,21.2860107 13.5101749,20.9677088 13.9457618,20.6130947 C15.1901949,19.5999935 16.4346958,18.4977774 17.5976704,17.3429285 C19.4003909,15.5528036 20.8394441,13.8020676 21.7825404,12.1427661 C22.5747774,10.7488894 23,9.44662657 23,8.24936117 C23,1.2374529 14.6683498,-0.396099541 12,6.04168892 Z" id="Path" fill="#E73246"></path>
                                    <path v-else d="M12,6.04168892 C9.33165018,-0.396099541 1,1.2374529 1,8.24936117 C1,9.44662657 1.42522258,10.7488894 2.21745959,12.1427661 C3.16055591,13.8020676 4.5996091,15.5528036 6.4023296,17.3429285 C7.56530417,18.4977774 8.80980511,19.5999935 10.0542382,20.6130947 C10.4898251,20.9677088 10.8944894,21.2860107 11.2579947,21.5633617 C11.4769961,21.7304577 11.6342722,21.8472421 11.7195736,21.9090561 C11.8869068,22.0303146 12.1130932,22.0303146 12.2804264,21.9090561 C12.3657278,21.8472421 12.5230039,21.7304577 12.7420053,21.5633617 C13.1055106,21.2860107 13.5101749,20.9677088 13.9457618,20.6130947 C15.1901949,19.5999935 16.4346958,18.4977774 17.5976704,17.3429285 C19.4003909,15.5528036 20.8394441,13.8020676 21.7825404,12.1427661 C22.5747774,10.7488894 23,9.44662657 23,8.24936117 C23,1.2374529 14.6683498,-0.396099541 12,6.04168892 Z" id="Path" fill="#575C61"></path>
                                </g>
                            </svg>
                        </a>
                        <div class="download__wrapper">
                            <btn v-if="plugin.type == 'addon'" :href="'https://api.library.loxone.com/downloader/' + plugin.id" :text="$t('page.detail.download')" />
                            <btn v-if="plugin.type == 'plugin' && plugin.button_url && plugin.button_text" :target="'_blank'" :href="plugin.button_url" :text="plugin.button_text" />
                            <btn v-if="plugin.type == 'plugin' &&  (!plugin.button_url || !plugin.button_text)" :target="'_blank'" :href="'https://www.loxone.com/enen/support/downloads/'" :class="'btn--info'" :text="$t('page.detail.included')" />
                        </div>
                    </div>
                </div>
                <div v-if="plugin && plugin.type == 'addon'">
                    <detail-tabs @toggle-tabs="toggleTabs" :currentPage="currentPage"></detail-tabs>
                </div>
            </div>
        </section>
        <placeholder v-else :type="'plugin.header'"></placeholder>
    </div>
    <main v-if="currentPage == 'overview'" class="overview">
        <div v-if="plugin" class="container grid grid--9-3 grid--offset-big">
            <section class="overview">
                <h2>{{$t('title.description')}}</h2>
                <div class="tab__wrapper">
                    <div v-if="false" class="tab__content--top">
                        <ul>
                            <template v-for="tab in tabs" :key="tab.id">
                                <li @click="toggleTab(tab)" :class="getTabClass(tab)" v-if="tab.active">
                                    {{tab.label}}
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div class="tab__content--bottom">
                        <template v-for="tab in tabs" :key="tab.id">
                            <div v-if="tab.selected" class="tab__entry">
                                <div class="description">
                                    {{tab.short_desc}}
                                </div>
                                <div class="description" v-html="updateDescription(tab.description)"></div>
                            </div>
                        </template>
                    </div>
                </div>
                <template v-if="plugin.config_path != ''">
                    <h2>{{$t('page.creator.config_example')}}</h2>
                    <a :href="'https://api.library.loxone.com/downloader/config/' + plugin.id" class="config__example--wrapper">
                        <div class="config__exmaple--icon">
                            <svg width="64px" height="64px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <defs>
                                    <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                                        <stop stop-color="#F5F6F6" offset="0%"></stop>
                                        <stop stop-color="#F2F3F4" offset="100%"></stop>
                                    </linearGradient>
                                </defs>
                                <g id="Loxone_File" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <path d="M14.25,0.5 L18.875,5.125 L18.875,21.5 L3.125,21.5 L3.125,0.5 L14.25,0.5 Z M14.2111563,0.59375 L3.21875,0.59375 L3.21875,21.40625 L18.78125,21.40625 L18.78125,5.16384375 L14.2111563,0.59375 Z" id="Rectangle" fill="#979797" fill-rule="nonzero"></path>
                                    <polygon id="Path" fill="url(#linearGradient-1)" fill-rule="nonzero" points="14.1723437 0.6875 3.3125 0.6875 3.3125 21.3125 18.6875 21.3125 18.6875 5.20265625"></polygon>
                                    <polygon id="Path" fill="#979797" fill-rule="nonzero" points="14.25 0.5 18.875 5.125 14.25 5.125"></polygon>
                                    <polygon id="Path" fill="#E3E3E3" fill-rule="nonzero" points="14.34375 0.72634375 14.34375 5.03125 18.6486563 5.03125"></polygon>
                                    <rect id="Rectangle" fill="#69C350" x="0.8125" y="5.09375" width="13" height="4.5"></rect>
                                    <path d="M3.41375,8.3125 L3.41375,7.94 L2.66875,7.94 L2.66875,6.5375 L2.24875,6.5375 L2.24875,8.3125 L3.41375,8.3125 Z M4.47125,8.3375 C5.00125,8.3375 5.38125,7.9675 5.38125,7.425 C5.38125,6.88 5.00125,6.5125 4.47125,6.5125 C3.92875,6.5125 3.55625,6.89 3.55625,7.425 C3.55625,7.9575 3.92875,8.3375 4.47125,8.3375 Z M4.47125,7.9475 C4.18875,7.9475 3.99125,7.715 3.99125,7.425 C3.99125,7.1325 4.18875,6.9025 4.47125,6.9025 C4.74625,6.9025 4.94625,7.1275 4.94625,7.425 C4.94625,7.72 4.74625,7.9475 4.47125,7.9475 Z M5.99125,8.3125 L6.34625,7.74 L6.35375,7.74 L6.70625,8.3125 L7.19375,8.3125 L6.62875,7.42 L7.17125,6.5375 L6.69625,6.5375 L6.35375,7.095 L6.34625,7.095 L6.00375,6.5375 L5.52375,6.5375 L6.07125,7.42 L5.50375,8.3125 L5.99125,8.3125 Z M8.23125,8.3375 C8.76125,8.3375 9.14125,7.9675 9.14125,7.425 C9.14125,6.88 8.76125,6.5125 8.23125,6.5125 C7.68875,6.5125 7.31625,6.89 7.31625,7.425 C7.31625,7.9575 7.68875,8.3375 8.23125,8.3375 Z M8.23125,7.9475 C7.94875,7.9475 7.75125,7.715 7.75125,7.425 C7.75125,7.1325 7.94875,6.9025 8.23125,6.9025 C8.50625,6.9025 8.70625,7.1275 8.70625,7.425 C8.70625,7.72 8.50625,7.9475 8.23125,7.9475 Z M9.80375,8.3125 L9.80375,7.2475 L9.80625,7.2475 L10.48125,8.3125 L10.91125,8.3125 L10.91125,6.5375 L10.49375,6.5375 L10.49375,7.63 L9.80375,6.5375 L9.38625,6.5375 L9.38625,8.3125 L9.80375,8.3125 Z M12.43125,8.3125 L12.43125,7.94 L11.63125,7.94 L11.63125,7.6175 L12.22125,7.6175 L12.22125,7.25 L11.63125,7.25 L11.63125,6.91 L12.37875,6.91 L12.37875,6.5375 L11.22125,6.5375 L11.22125,8.3125 L12.43125,8.3125 Z" id="LOXONE" fill="#FFFFFF" fill-rule="nonzero"></path>
                                </g>
                            </svg>
                        </div>
                        <div class="config__exmaple--meta">
                            <div>
                                <span class="title"><b>{{$t('page.creator.config_example')}}:</b> {{plugin.name}}.loxone</span>
                                <span class="info">{{$t('page.detail.config_file')}}</span>
                            </div>
                            <div class="config__exmaple--download">
                                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <g id="dowload" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                        <path d="M0.5,18 C0.745459889,18 0.94960837,18.1768752 0.991944331,18.4101244 L1,18.5 L1,20.42 C1,21.668657 2.02857008,22.7040846 3.33446447,22.7849209 L3.49909132,22.79 L20.5009087,22.79 C21.8278506,22.79 22.9102266,21.8097418 22.9946936,20.5843921 L23,20.43 L23,18.52 C23,18.2438576 23.2238576,18.02 23.5,18.02 C23.7454599,18.02 23.9496084,18.1968752 23.9919443,18.4301244 L24,18.52 L24,20.43 C24,22.2278551 22.528064,23.6895903 20.6920902,23.7850417 L20.5009087,23.79 L3.49909132,23.79 C1.6373308,23.79 0.105267507,22.3815767 0.00519857739,20.6050492 L0,20.42 L0,18.5 C0,18.2238576 0.223857625,18 0.5,18 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
                                        <path d="M12.0052249,0.5 C12.2506848,0.5 12.4548333,0.676875161 12.4971692,0.910124368 L12.5052249,1 L12.5052249,18.11 C12.5052249,18.3861424 12.2813673,18.61 12.0052249,18.61 C11.759765,18.61 11.5556165,18.4331248 11.5132806,18.1998756 L11.5052249,18.11 L11.5052249,1 C11.5052249,0.723857625 11.7290825,0.5 12.0052249,0.5 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
                                        <path d="M18.9743884,10.7387575 C19.1738972,10.5478364 19.4904031,10.554798 19.6813242,10.7543067 C19.8510319,10.9316477 19.8643878,11.2014311 19.7251393,11.3932836 L19.6657751,11.4612425 L12.3509182,18.4612425 C12.181753,18.6231263 11.9273036,18.6433617 11.7368173,18.5219489 L11.6595316,18.4612425 L4.34467468,11.4612425 C4.14516598,11.2703213 4.13820439,10.9538154 4.32912555,10.7543067 C4.49883324,10.5769656 4.76776842,10.5517605 4.96555798,10.6824388 L5.03606135,10.7387575 L12.005,17.407 L18.9743884,10.7387575 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </a>
                </template>
                <template v-if="plugin.attachments && plugin.attachments.length > 0">
                    <h2>Additional Downloads</h2>
                    <file-list :files="plugin.attachments" :remove="false" :download="true"></file-list>
                </template>
                <template v-if="ios && Object.keys(ios).length">
                    <template v-if="ios.inputs && Object.keys(ios.inputs).length">
                        <h2>{{$t('page.detail.inputs')}}</h2>
                        <table class="io__table">
                            <thead>
                                <tr>
                                    <td>{{$t('page.detail.name')}}</td>
                                    <td v-if="ios.meta.input_comments">{{$t('page.detail.description')}}</td>
                                    <td>{{$t('page.detail.type')}}</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="input in ios.inputs" :key="input.id">
                                    <td>{{input.title}}</td>
                                    <td v-if="ios.meta.input_comments">{{input.comment}}</td>
                                    <td v-html="handleType(input.analog, 'input')"></td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-if="ios.outputs && Object.keys(ios.outputs).length">
                        <h2>{{$t('page.detail.outputs')}}</h2>
                        <table class="io__table">
                            <thead>
                                <tr>
                                    <td>{{$t('page.detail.name')}}</td>
                                    <td v-if="ios.meta.output_comments">{{$t('page.detail.description')}}</td>
                                    <td>{{$t('page.detail.type')}}</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="output in ios.outputs" :key="output.id">
                                    <td>{{output.title}}</td>
                                    <td v-if="ios.meta.output_comments">{{output.comment}}</td>
                                    <td v-html="handleType(output.analog, 'output')"></td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </template>
                <template v-if="faqs && Object.keys(faqs).length">
                    <h2>FAQ</h2>
                    <div class="faq">
                        <faq-entry v-for="faq in faqs" :key="faq.faq_sorting" :data="faq"></faq-entry>
                    </div>
                </template>
                <template v-if="versions && versions.public && Object.keys(versions.public).length > 1">
                    <h2 id="versions">{{$t('title.version_history')}}</h2>
                    <div class="history">
                        <version-entry v-for="version in versions.public" :key="version.id" :data="version"></version-entry>
                    </div>
                </template>
            </section>
            <aside v-if="versions" class="meta">
                <div v-if="plugin.type == 'addon' && versions.latest_public" class="meta__entry">
                    <h4>{{$t('page.detail.version')}}</h4>
                    <span>{{versions.latest_public.version_number}}</span>
                </div>
                <div v-if="versions.latest_public" class="meta__entry">
                    <h4>{{$t('page.detail.published')}}</h4>
                    <span>{{versions.latest_public.uploaded}}</span>
                </div>
                <div v-if="plugin.config_version" class="meta__entry">
                    <h4>{{$t('page.detail.config_version')}}</h4>
                    <span>{{plugin.config_version}}</span>
                </div>
                <div v-if="plugin.type == 'addon'" class="meta__entry">
                    <h4>{{$t('page.detail.brand')}}</h4>
                    <span>{{plugin.brands.value}}</span>
                </div>
                <div v-if="plugin.devices && Object.keys(plugin.devices).length > 1" class="meta__entry">
                    <h4>{{$t('page.detail.supported_devices')}}</h4>
                    <span v-for="device in plugin.devices" :key="device.id">&bull; {{device.value}}</span>
                </div>
                <div class="meta__links"  v-if="plugin.type == 'addon'">
                    <a v-if="versions && Object.keys(versions.all).length > 1" href="#versions">{{$t('page.detail.version_history')}}</a>
                    <a @click="contactButton">{{$t('page.detail.contact')}}</a>
                    <a v-if="$store.state.loggedIn" @click="reportAbuse">{{$t('page.detail.report_abuse')}}</a>
                </div>
                <div v-if="plugin.certified" class="meta__entry">
                    <svg width="192" height="68" viewBox="0 0 327 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0)">
                            <rect x="2.33203" y="1.55103" width="323.522" height="112.388"/>
                            <path d="M130.166 54.377L133.823 42.3128H133.854L137.511 54.377H141.605L148.289 35.2008H143.758L139.583 47.8577H139.502L135.723 35.2008H131.994L128.256 47.8175H128.175L124 35.2008H119.469L126.143 54.377H130.166Z" fill="#1B1B19"/>
                            <path d="M158.742 54.6883C164.705 54.6883 168.921 50.6401 168.921 44.824C168.921 38.9275 164.705 34.9194 158.742 34.9194C152.626 34.9194 148.563 39.1685 148.563 44.824C148.563 50.4493 152.616 54.6883 158.742 54.6883ZM158.742 38.8973C161.922 38.8973 164.39 41.2981 164.39 44.834C164.39 48.2895 161.891 50.6903 158.742 50.6903C155.4 50.6903 153.094 48.0987 153.094 44.834C153.094 41.489 155.359 38.8973 158.742 38.8973Z" fill="#1B1B19"/>
                            <path d="M176.865 45.2961C176.865 42.152 178.775 39.7512 182.147 39.7512C182.462 39.7512 182.98 39.7913 183.498 39.8315V34.9194H182.94C180.593 34.9194 178.409 36.0545 176.895 38.1038H176.855V35.2007H172.405V54.3769H176.855V45.2961H176.865Z" fill="#1B1B19"/>
                            <path d="M190.498 49.8567L193.718 46.3208H193.789L198.838 54.3771H203.846L196.735 42.9457L203.725 35.2008H198.442L190.498 43.9602V25.457H186.038V54.3771H190.498V49.8567Z" fill="#1B1B19"/>
                            <path d="M212.35 50.841C209.963 50.841 208.297 50.0977 206.742 48.6009L204.517 51.9058C206.549 53.6737 209.211 54.6983 212.35 54.6983C217.277 54.6983 219.583 52.1067 219.583 48.8822C219.583 45.0751 217.003 44.3217 212.868 42.7144C210.999 42.0113 209.81 41.3383 209.81 40.394C209.81 39.2187 211.039 38.7466 211.913 38.7466C213.427 38.7466 215.215 39.3393 216.759 40.7858L218.983 37.3302C216.84 35.6025 214.615 34.9294 212.147 34.9294C208.175 34.9294 205.31 37.2097 205.31 40.3538C205.31 44.1308 208.053 45.5371 211.232 46.6421C213.772 47.506 215.052 47.9781 215.052 48.9625C215.052 50.0977 214.067 50.841 212.35 50.841Z" fill="#1B1B19"/>
                            <path d="M241.048 54.377L244.705 42.3128H244.746L248.403 54.377H252.497L259.171 35.2008H254.64L250.465 47.8577H250.394L246.615 35.2008H242.876L239.138 47.8175H239.067L234.892 35.2008H230.361L237.035 54.377H241.048Z" fill="#1B1B19"/>
                            <path d="M266.526 35.2008H262.076V54.377H266.526V35.2008Z" fill="#1B1B19"/>
                            <path d="M264.301 32.368C265.967 32.368 267.318 31.032 267.318 29.4248C267.318 27.8577 265.967 26.5217 264.301 26.5217C262.635 26.5217 261.325 27.8577 261.325 29.4248C261.314 31.032 262.635 32.368 264.301 32.368Z" fill="#1B1B19"/>
                            <path d="M271.656 48.3297C271.656 52.609 273.728 54.6984 277.06 54.6984C279.6 54.6984 280.839 54.1861 281.987 53.5633L280.839 49.7562C279.803 50.3086 278.737 50.5799 277.975 50.5799C276.705 50.5799 276.105 49.8767 276.105 47.9079V38.9476H281.784V35.2108H276.105V28.37L271.656 28.8421V35.2108H269.269V38.9476H271.656V48.3297Z" fill="#1B1B19"/>
                            <path d="M289.099 44.6333C289.099 40.8563 291.09 38.8975 294.31 38.8975C296.972 38.8975 298.526 40.2335 298.526 44.0506V54.3871H302.975V42.9055C302.975 37.1697 299.999 34.9296 295.742 34.9296C293.121 34.9296 290.775 35.8337 289.139 37.6418H289.099V25.457H284.649V54.3771H289.099V44.6333Z" fill="#1B1B19"/>
                            <path d="M126.824 60.665H122.019V88.5705H139.898V84.3214H126.824V60.665Z" fill="#1B1B19"/>
                            <path d="M151.945 69.1133C145.83 69.1133 141.766 73.3624 141.766 79.0178C141.766 84.6331 145.82 88.8822 151.945 88.8822C157.909 88.8822 162.124 84.834 162.124 79.0178C162.114 73.1213 157.898 69.1133 151.945 69.1133ZM151.945 84.8741C148.603 84.8741 146.297 82.2825 146.297 79.0178C146.297 75.6728 148.563 73.0811 151.945 73.0811C155.125 73.0811 157.594 75.4819 157.594 79.0178C157.584 82.4733 155.084 84.8741 151.945 84.8741Z" fill="#1B1B19"/>
                            <path d="M162.195 69.3944L168.991 78.7866L162.154 88.5706H167.081L171.531 82.5134H171.572L175.991 88.5706H180.958L174.081 78.8168L180.836 69.3944H175.706L171.531 75.4416H171.5L167.366 69.3944H162.195Z" fill="#1B1B19"/>
                            <path d="M191.127 88.8822C197.09 88.8822 201.306 84.834 201.306 79.0178C201.306 73.1213 197.09 69.1133 191.127 69.1133C185.002 69.1133 180.948 73.3624 180.948 79.0178C180.958 84.6431 185.012 88.8822 191.127 88.8822ZM191.127 73.0811C194.307 73.0811 196.775 75.4819 196.775 79.0178C196.775 82.4733 194.276 84.8741 191.127 84.8741C187.785 84.8741 185.479 82.2825 185.479 79.0178C185.489 75.6828 187.755 73.0811 191.127 73.0811Z" fill="#1B1B19"/>
                            <path d="M209.292 72.0666H209.251V69.3945H204.802V88.5707H209.251V78.9475C209.251 75.1705 211.242 73.0912 214.259 73.0912C216.921 73.0912 218.475 74.387 218.475 78.4352V88.5707H222.925V77.29C222.925 71.5141 220.06 69.1133 215.814 69.1133C213.304 69.1133 210.927 70.1379 209.292 72.0666Z" fill="#1B1B19"/>
                            <path d="M235.958 88.8821C239.777 88.8821 242.52 87.3452 244.146 85.2659L241.047 82.634C240.052 83.8495 238.467 84.8741 236.201 84.8741C233.337 84.8741 231.274 83.2267 230.675 80.5145H244.826C244.867 80.1629 244.948 79.4497 244.948 78.7466C244.948 73.1715 241.25 69.1233 235.531 69.1233C230.127 69.1233 226.073 73.0911 226.073 78.9876C226.063 84.9545 230.32 88.8821 235.958 88.8821ZM235.765 73.0811C238.304 73.0811 239.899 74.6582 240.458 76.9686H230.756C231.386 74.4573 233.296 73.0811 235.765 73.0811Z" fill="#1B1B19"/>
                            <path d="M0.947266 0.112915V115.19H327V0.112915H0.947266ZM325.08 113.292H2.86725V2.01145H325.08V113.292Z" fill="#1B1B19"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M62.7529 24.0002H25.8972V80.1126L62.7529 24.0002ZM93.9604 36.5868V91.3029H58.0291L93.9589 91.3029V36.5891L93.9604 36.5868Z" fill="#69C350"/>
                            <path d="M58.0298 91.3028L93.961 36.5868V91.3028H58.0298Z" fill="#69C350" fill-opacity="0.4"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M62.7529 24.0002L25.8972 80.1126V91.3029H58.0291L93.9604 36.5868V24.0002H62.7529Z" fill="#69C350" fill-opacity="0.7"/>
                        </g>
                        <defs>
                            <clipPath id="clip0">
                                <rect width="326.053" height="115.077" fill="white" transform="translate(0.947266 0.112915)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </aside>
        </div>
        <placeholder v-else :type="'page.overview'"></placeholder>
    </main>
    <main v-if="currentPage == 'rating'" class="rating">
        <placeholder v-if="!plugin" :type="'page.support'"></placeholder>
        <section v-else class="rating__wrapper">
            <div v-if="$store.state.loggedIn" class="rating__top">
                <div class="container">
                    <h4>{{$t('page.detail.rate_template')}}</h4>
                    <span class="rating__title">{{currentRatingText()}}</span>
                    <div class="rating__stars" :class="currentRatingClass()">
                        <svg @click="ratePlugin(star)" class="star" v-for="star in 5" :key="star" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 260 245"><path fill="rgba(0,0,0,0.24)" d="m55,237 74-228 74,228L9,96h240"/></svg>
                    </div>
                    <div v-if="currentRating > 0" class="rating__text--wrapper">
                        <textarea class="styled" v-model="comment" id="comment" name="comment" rows="13" cols="130" :placeholder="$t('page.detail.rating_placeholder')"></textarea>
                        <btn @click="resetComment()" :class="'btn--light'" :text="$t('page.detail.comments.cancel')" />
                        <btn @click="submitComment()" :text="$t('page.detail.comments.send')"/>
                    </div>
                </div>
            </div>
            <div v-if="comments && Object.keys(comments).length > 0" class="rating__bottom">
                <div class="container">
                    <h2>{{$t('page.detail.ratings')}}</h2>
                    <div class="comments">
                        <plugin-comment
                            v-for="comment in comments"
                            :key="comment.id"
                            :type="'comment'"
                            :comment="comment"
                            :replies="comment.replies"></plugin-comment>
                    </div>
                </div>
            </div>
        </section>
    </main>
    <main v-if="currentPage == 'support'" class="support">
        <section v-if="plugin" class="support__wrapper">
            <div class="rating__bottom">
                <div class="container">
                    <h2>{{$t('page.detail.issues')}}&nbsp;<a v-if="$store.state.loggedIn" href="#submitIssue" class="btn">{{$t('page.detail.add_issue') }}</a><a v-else href="/login" class="btn">{{$t('page.detail.login') }}</a></h2>
                    <div v-if="issues" class="comments">
                        <plugin-comment
                            v-for="comment in issues"
                            :key="comment.id"
                            :type="'issue'"
                            :comment="comment"
                            :replies="comment.replies"></plugin-comment>
                    </div>
                    <div v-else>
                        <div class="no_issue">{{$t('page.detail.no_issues')}}</div>
                    </div>
                    <div v-if="$store.state.loggedIn" class="submit_issue" id="submitIssue">
                        <h3>{{ $t('page.detail.add_issue') }}</h3>
                        <input v-model="issueTitle" type="text" :placeholder="$t('page.detail.issue_title_placeholder')"/>
                        <textarea class="styled" v-model="issue" id="issue" name="issue" rows="13" cols="130" :placeholder="$t('page.detail.issue_placeholder')"></textarea>
                        <div style="text-align:right;padding-top:20px;">
                            <btn @click="resetIssue()" :class="'btn--light'" :text="$t('page.detail.comments.cancel')" />
                            <btn @click="submitIssue()" :text="$t('page.detail.comments.send')"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="support__top">
                <div v-if="plugin.creator" class="container">
                    <h4>{{$t('page.detail.support_text')}}</h4>
                    <img :src="plugin.creator.logo" />
                    <div class="support__meta">
                        <h3>{{plugin.creator.value}}</h3>
                        <span class="phone">{{$t('page.detail.phone')}} {{plugin.creator.phone}}</span>
                        <span class="mail">{{$t('page.detail.email')}} <a>{{plugin.creator.email}}</a></span>
                        <span class="website" v-if="plugin.creator.website"><a target="_blank" :href="plugin.creator.website">Website</a></span>
                    </div>
                </div>
            </div>
        </section>
        <placeholder v-else :type="'page.support'"></placeholder>
    </main>
    <footer v-if="currentPage == 'overview'">
        <plugin-category
            :title="$t('page.detail.similar_title')"
            :description="$t('page.detail.similar_desc')"
            :plugins="similarPlugins"
        ></plugin-category>
    </footer>
</template>

<script>
    import FaqEntry from '@/components/FaqEntry.vue';
    import VersionEntry from '@/components/VersionEntry.vue';
    import axios from 'axios'
    import PluginCategory from '@/components/PluginCategory.vue';
    import PluginComment from '@/components/PluginComment.vue';
    import DetailTabs from '@/components/DetailTabs.vue';
    import PluginLogo from '@/components/PluginLogo.vue';
    import FileList from '@/components/FileList.vue';
    import Placeholder from '@/components/Placeholder.vue';
    import Btn from '@/components/Button.vue';
    export default {
        components: {
            FaqEntry,
            VersionEntry,
            PluginCategory,
            DetailTabs,
            PluginLogo,
            PluginComment,
            Placeholder,
            FileList,
            Btn
        },

        data() {
            return {
                showEntireDescription: true,
                faqs: null,
                plugin: null,
                versions: null,
                plugin_id_url: window.location.href.split('/')[4].substring(window.location.href.split('/')[4].lastIndexOf('-') + 1),
                plugin_id: window.location.href.split('/')[4],
                similarPlugins: null,
                availableLanguages: null,
                issue: '',
                issueTitle: '',
                ios: [],
                tabs: {
                    en_gb: {
                        label:        this.$t('languages.en_gb'),
                        code:         'en_gb',
                        mandatory:    true,
                        selected:     true,
                        active:       true,
                        short_desc:   '',
                        description:  ''
                    }
                },
                showTabs: false,
                currentRating: 0,
                comment: '',
                comments: null,
                issues: {},
                allowedToRate: true,
                currentPage: 'overview',
            }
        },

        methods: {
            resetIssue() {

            },
            loadInitialPage() {
                this.showEntireDescription = true;
                this.faqs = null;
                this.plugin = null;
                this.versions = null;
                this.plugin_id_url = window.location.href.split('/')[4].substring(window.location.href.split('/')[4].lastIndexOf('-') + 1);
                this.plugin_id = window.location.href.split('/')[4];
                this.similarPlugins = null;
                this.availableLanguages = null;
                this.ios = [];
                this.showTabs = false;
                this.currentRating = 0;
                this.comment = '';
                this.comments = null;
                this.comments = null;
                this.allowedToRate = true;
                this.currentPage = 'overview';
                this.tabs = {
                    en_gb: {
                        label:        this.$t('languages.en_gb'),
                        code:         'en_gb',
                        mandatory:    true,
                        selected:     true,
                        active:       true,
                        short_desc:   '',
                        description:  ''
                    }
                };
                

                switch(window.location.href.split('/')[5]) {
                    case 'rating':
                        this.currentPage = 'rating';
                        break;
                    case 'support':
                        this.currentPage = 'support';
                        break;
                    default:
                        this.currentPage = 'overview';
                        break;
                }


                var pluginInfo = new FormData();
                pluginInfo.append('plugin', this.plugin_id_url);
                pluginInfo.append('plugin_id', this.plugin_id_url);
                
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/loadPluginDetail',
                    data: pluginInfo,
                }).then(resp => {
                    this.plugin = resp.data
                    var similarPlugins = new FormData();
                    similarPlugins.append('filter', JSON.stringify({
                        technologies: [resp.data.technologies.id],
                    }));

                    similarPlugins.append('exclude', resp.data.plugin_id);
                    similarPlugins.append('orderby', 'p.plugin_downloads');
                    similarPlugins.append('order', 'DESC');
                    similarPlugins.append('limit', '0,3');
                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        url: 'https://api.library.loxone.com/loadFilteredPlugins',
                        data: similarPlugins,
                    }).then(response => {
                        this.similarPlugins = response.data
                    });
                });

                
            
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/loadTranslations',
                    data: pluginInfo,
                }).then(response => {
                    for (const [key, value] of Object.entries(response.data)) {
                        for (const [sub_key, sub_value] of Object.entries(this.tabs)) {
                            if(key == sub_key) {
                                sub_value.short_desc = value.short_description;
                                sub_value.description = value.description;
                                sub_value.active = true;
                            }
                        }
                    }
                    if(Object.keys(response.data).length > 1) {
                        this.showTabs = true;
                    }
                });

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/loadFaqs',
                    data: pluginInfo,
                })
                .then(resp => {
                    if (resp.data) {
                        this.faqs = resp.data;
                    }
                });

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/loadPluginVersions',
                    data: pluginInfo,
                })
                .then(resp => {
                    if (resp.data) {
                        this.versions = resp.data;
                    }
                });

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/loadIOs',
                    data: pluginInfo,
                })
                .then(response => {
                    if (response.data) {
                        this.ios = response.data;
                    }
                });

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/loadComments',
                    data: pluginInfo,
                }).then(response => {
                    console.log("comments", response.data);
                    this.comments = response.data;
                });

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/loadIssues',
                    data: pluginInfo,
                }).then(response => {
                    console.log("issues", response.data);
                    this.issues = response.data;
                });
            },

            handleType(isAnalog, type) {
                var text = '';
                var icon = '';
                var path = 'https://api.library.loxone.com/files/global/icons/io/';
                if(type == 'input' && isAnalog) {
                    // Analog Input
                    text = this.$t('page.detail.analogue');
                    icon = 'analog-input.svg';
                } else if(type == 'input') {
                    // Digital Input
                    text = this.$t('page.detail.digital');
                    icon = 'digital-input.svg';
                }

                if(type == 'output' && isAnalog) {
                    // Analog Output
                    text = this.$t('page.detail.analogue');
                    icon = 'analog-output.svg';
                } else if(type == 'output') {
                    // Digital Output
                    text = this.$t('page.detail.digital');
                    icon = 'digital-output.svg';
                }
                return '<img class="io--icon" src="' + path + icon + '" /> ' + text;
            },

            toggleDescription() {
                this.showEntireDescription = !this.showEntireDescription;
            },

            contactButton() {
                this.$router.push({ name: 'Detail', params: { id: this.plugin_id, page: 'support' }});
                this.currentPage = 'support';
            },
            reportAbuse() {
                this.$router.push({ name: 'ReportAbuse', params: { id: this.plugin_id }})
            },

            toggleTab(tab) {
                for (const [key, value] of Object.entries(this.tabs)) {
                    value.selected = false;
                    if(key == tab.code) {
                        value.selected = true;
                    }
                }
            },
            getTabClass(tab) {
                var className = "";

                className = 'tab';

                if(tab.mandatory) {
                    className += ' mandatory';
                }

                if(tab.selected) {
                    className += ' active';
                }

                return className;
            },
            updateDescription(text) {
                if(!text) {
                    return '';
                }
                if(text == "<p>-</p>") {
                    return '';
                }
                text = text.replaceAll('<iframe', '<div class="youtube_iframe"><iframe', text);
                text = text.replaceAll('</iframe>', '</iframe></div>', text);
                return text;
            },
            toggleTabs(page) {
                switch(page) {
                    case 'rating':
                        this.currentPage = 'rating';
                        break;
                    case 'support':
                        this.currentPage = 'support';
                        break;
                    default:
                        this.currentPage = 'overview';
                        break;
                }
            },
            beautifyDownloads() {
                const ds = this.plugin.downloads;

                if(ds < 50) {
                    return this.$t('downloads.less_than_50');
                } else if(ds < 100) {
                    return '50+ Downloads';
                } else {
                    return Math.floor(ds/100)*100 + '+ Downloads'
                }
            },
            togglePluginHighlight() {
                var highlightMeta = new FormData();
                highlightMeta.append('user_id', this.$store.state.userData.user_id);
                highlightMeta.append('plugin_id', this.plugin.plugin_id);
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/toggleHighlight',
                    data: highlightMeta,
                }).then(() => (this.plugin.highlight = !this.plugin.highlight));
            },
            toggleInterface() {
                this.interfaceVisible = !this.interfaceVisible;
            },
            ratePlugin(rating) {
                this.currentRating = rating;
            },
            currentRatingText() {
                switch(this.currentRating) {
                    case 1:
                        return this.$t('page.detail.rating.1');
                    case 2:
                        return this.$t('page.detail.rating.2');
                    case 3:
                        return this.$t('page.detail.rating.3');
                    case 4:
                        return this.$t('page.detail.rating.4');
                    case 5:
                        return this.$t('page.detail.rating.5');
                    default:
                        return this.$t('page.detail.rating.6');
                }
            },
            currentRatingClass() {
                return 'current--' + this.currentRating;
            },
            resetComment() {
                this.currentRating = 0;
                this.comment = '';
            },
            submitComment() {
                var commentMeta = new FormData();
                commentMeta.append('user_id', this.$store.state.userData.user_id);
                commentMeta.append('plugin_id', this.plugin_id_url);
                commentMeta.append('comment_rating', this.currentRating);
                commentMeta.append('text', this.comment);
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/addComment',
                    data: commentMeta,
                }).then(() => (location.reload()));
            },
            submitIssue() {
                var commentMeta = new FormData();
                commentMeta.append('user_id', this.$store.state.userData.user_id);
                commentMeta.append('plugin_id', this.plugin_id_url);
                commentMeta.append('title', this.issueTitle);
                commentMeta.append('text', this.issue);
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/addIssue',
                    data: commentMeta,
                }).then((response) => {
                    console.log(response.data)
                    location.reload()
                });
            }
        },
        
        created() {
            this.loadInitialPage();
        },

        watch: {
            '$route.params.id': function (id) {
                if(this.$route.name == 'Detail') {
                    this.loadInitialPage()
                }
            }
        }
    }
</script>

<style lang="scss">

    .config__example--wrapper{
        border: 1px solid #D9D9D9;
        background-color: #FFFFFF;
        display: flex;
        justify-content: flex-start;
        cursor: pointer;

        img{
            display: block;
        }

        .config__exmaple--icon{
            padding: 15px;
            border-right: 1px solid #D9D9D9;
        }

        .config__exmaple--meta{
            padding: 15px;
            width: 100%;
            display: flex;
            justify-content: space-between;

            span{
                display: block;

                &.title{
                    color: #000000;
                    font-size: 16px;
                    padding: 5px 0 2px 0;
                }

                &.info{
                    color: #808080;
                    font-size: 14px;
                }
            }
        }

        .config__exmaple--download{
            padding: 16px;
        }
    }

    .rating__counter{
        margin-left: 10px;
        vertical-align: text-bottom;
    }
    @import '../scss/utilities/variables';
    @import '../scss/pages/detail';

    .header__top{
        padding-bottom: 30px;
    }
</style>